import React, { useEffect, useState } from "react";
import CustomTextbox from "../../components/Forms/CustomInputs/CustomTextbox";
import { useSelector } from "react-redux";
import CustomDropdownMultiple from "../../components/Forms/CustomInputs/CustomDropdownMultiple";

const AddUpdateUI = ({ formik, relationData }) => {
  const { data: categories } = useSelector((state) => state.category);
  const { values, errors, handleChange, handleBlur, setFieldValue } = formik;
  const [selectedCategory, setSelectedCategory] = useState([]);
  useEffect(() => {
    if (values?.access?.length === 0) {
      setSelectedCategory([]);
      return;
    }
    const categoryArray = values?.access?.map((cat) => ({
      label: cat,
      value: cat,
    }));
    setSelectedCategory(categoryArray);
  }, [formik]);
  return (
    <>
      <CustomTextbox
        fieldName="title"
        value={values.title}
        error={errors.title}
        label={"Role Title"}
        classes={"col-md-12"}
        handleBlur={handleBlur}
        inputType={"text"}
        handleChange={handleChange}
      />

      <CustomDropdownMultiple
        fieldName="access"
        values={selectedCategory}
        error={errors.access}
        label={"Select Access Levels"}
        classes={"col-md-12"}
        setFieldValue={setFieldValue}
        handleChange={(value) => setSelectedCategory(value)}
        options={[
          { label: "dashboard", value: "dashboard" },
          { label: "projects", value: "projects" },
          { label: "artists", value: "artists" },
          { label: "audience", value: "audience" },
          { label: "organisation", value: "organisation" },
          // { label: "organisation", value: "users" },
          { label: "abhivyakti", value: "abhivyakti" },
          { label: "master", value: "master" },
          { label: "appfeed", value: "appfeed" },
          { label: "app configuration", value: "config" },
        ]}
      />
    </>
  );
};

export default AddUpdateUI;
